module.exports = __webpack_public_path__ + "img/symbol_8.1a2597b9.png";